import styled, { css } from 'styled-components';
import { customMedia } from 'styles/utils';

import Button from 'components/Button';
import { Checkbox } from 'libs/forms/styles';
import Input from 'components/Form/Input';

const THUMB_SIZE = 7;
const THUMB_BORDER_SIZE = 2;

export const TreeStyled = styled.nav`
  position: relative;
  z-index: 1001;
  height: 100%;
`;

export const ClipListStyled = styled.ul`
  font-size: ${props => props.theme.font.size.small};
`;

export const ClipPlaneStyled = styled.li`
  margin: ${props => props.theme.spacing.default} 0;
  padding: 0 ${props => props.theme.spacing.small};

  border-left: 2px solid ${props => props.theme.color.wfGrey200};
  ${ClipListStyled} {
    padding: ${props => props.theme.spacing.xsmall} 0
      ${props => props.theme.spacing.xsmall} 0;
    margin: ${props => props.theme.spacing.xsmall} 0
      ${props => props.theme.spacing.xsmall} 0;

    small {
      font-size: 100%;
      margin: ${props =>
        `${props.theme.spacing.xsmall} 0 ${props.theme.spacing.xsmall}`};
      display: inline-block;
    }
  }
`;

export const ClipPlaneRow = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: auto 55px 40px;
  margin: ${props => props.theme.spacing.xsmall} 0
    ${props => props.theme.spacing.xsmall} 0;
`;

export const ClipLabelStyled = styled.div`
  padding-right: ${props => props.theme.spacing.small};
  font-weight: ${props => props.theme.font.weight.xbold};
  color: ${props => props.theme.color.wfGrey800};
  padding-left: 5px;
  border-left: 4px solid;
  border-color: ${props =>
    props.clipIx === 1
      ? props.theme.color.wfRed
      : props.clipIx === 2
      ? props.theme.color.wfGreen900
      : props.theme.color.wfBlue};
`;

export const ButtonsWrapper = styled.div`
  visibility: ${props => (props.active ? 'visible' : 'hidden')};
  height: 20px;
`;

export const ButtonStyled = styled(Button)`
  margin: 0;
  margin-right: ${props => props.theme.spacing.small};
  padding: 0;
  vertical-align: baseline;
  color: ${props => props.theme.color.wfGrey800};
  &:hover {
    color: ${props => props.theme.color.wfBlack};
  }
`;

export const CheckboxStyled = styled(Checkbox)``;

export const ClipSliderStyled = styled.li`
  opacity: ${props => !props.active && 0.2};
  height: 100%;
  width: 100%;
  position: relative;
  display: grid;
  color: ${props => props.theme.color.wfBlack};
  grid-template-columns: 38px 31px 7px auto;
  margin: ${props => props.theme.spacing.xsmall} 0
    ${props => props.theme.spacing.xsmall} 0;
`;

export const TextWrapper = styled.div`
  width: 30px;
  float: left;
  border-radius: ${props => props.theme.spacing.xsmall};
  border-width: 1px;
  border-style: solid;
  background: ${props => props.theme.color.wfWhite};
  border-color: ${props =>
    props.isTemp ? props.theme.color.wfOrange600 : props.theme.color.wfGrey800};
  margin: 1px;
  padding: 2px;
`;

export const SymbolWrapper = styled.div`
  width: 8px;
  float: left;
  padding-top: 4px;
  padding-left: 2px;
`;

export const SliderWrapper = styled.div`
  float: left;
  padding-top: 4px;
  margin-right: 10px;
  cursor: pointer;
  vertical-align: bottom;
  color: #000;

  ${customMedia.lessThan('medium')`
    transform: scale(0.9);
  `};
`;

export const InputStyled = styled(Input)`
  border-color: ${props =>
    props.isGhost ? 'transparent' : props.theme.color.wfGrey200};
  border-radius: ${props =>
    props.isGhost ? '0' : props.theme.borderRadius.large};
  color: ${props =>
    props.isTemp ? props.theme.color.wfGrey800 : props.theme.color.wfBlue};

  ${props =>
      props.isGhost &&
      `
    padding: 0;
    `}
    :focus {
    border: none;
  }
`;

const sliderThumb = css`
  width: ${THUMB_SIZE}px;
  height: ${THUMB_SIZE}px;
  border-radius: 50%;
  margin-top: -${(THUMB_SIZE + THUMB_BORDER_SIZE) / 2 + 1}px;
  background: ${props => props.theme.color.wfWhite};
  border: ${THUMB_BORDER_SIZE}px solid ${props => props.theme.color.wfBlue};
  cursor: pointer;
  box-sizing: content-box;
`;

// FIXME: Move these styles into future INPUT/slider component. Is mandatory to review and refactor css rules.
export const SliderInput = styled.input`
  width: 100%;
  height: 100%;
  margin-left: 5%;
  margin-bottom: ${props => props.theme.spacing.small};
  -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
  background: transparent; /* Otherwise white in Chrome */
  box-shadow: none;
  /* Track styling for WebKit/Blink */
  &::-webkit-slider-runnable-track {
    height: 1px;
    cursor: pointer;
    background: ${props => props.theme.color.wfGrey500};
  }
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    margin-top: -6px;
    ${sliderThumb}
  }

  /* Track styling for Firefox */
  &::-moz-range-track {
    height: 1px;
    cursor: pointer;
    background: ${props => props.theme.color.wfGrey500};
  }
  &::-moz-range-thumb {
    ${sliderThumb}
  }

  /* Track styling for IE */
  &::-ms-track {
    height: 2px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    border-width: 16px 0;
    color: transparent;
  }

  &::-ms-fill-lower,
  &::-ms-fill-upper {
    background: ${props => props.theme.color.wfGrey500};
    border-radius: 2px;
  }

  &::-ms-thumb {
    ${sliderThumb}
    margin-top: -6px;
  }

  ${customMedia.lessThan('medium')`
    transform: scale(0.9);
  `};
`;
